<template>
  <section class="sigle-choice">
    <div v-if="pageType === 'single'" class="left title">
      <span class="isRequred" v-if="isRequired">*</span>
      <span v-if="isShowNumber == 1">{{ qNo }}</span>
    </div>
    <div class="right">
      <div class="title" v-if="question.subject_title_type == 1">
        <span class="pure-text">{{
          question.title_quote_title_num !== 0 ? optionsTitle : question.subject
        }}</span>
      </div>
      <div v-else>
        <rich-text
          :type="2"
          :content="
            question.title_quote_title_num !== 0
              ? optionsTitle
              : question.subject
          "
        />
      </div>
      <div class="answer-list">
        <div
          v-if="
            question.option_quote_title_num !== 0 && answerList.length === 0
          "
        >
          本题选项源于前边题目的选项
        </div>
        <div e-else v-for="(item, idx) in answerList" :key="idx">
          <div class="answer-item" @click.stop="hanleSelect(item, idx)">
            <radio name="sigleType" :checked="item.checked" class="mr-8" />
            <rich-text :type="2" :content="item.option" />
          </div>
          <InputComps
            v-if="item.is_empty == 1 && item.checked"
            :value="item.details"
            :isRequired="item.is_required == 1"
            @change="handleInputChange($event, idx)"
          ></InputComps>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 单选题组件
 */
import Radio from '@/components/radio';
import RichText from '@/components/rich-text';
import InputComps from './input.vue';

export default {
  name: 'SingleChoice',
  components: { Radio, RichText, InputComps },
  props: {
    isShowNumber: {
      //是否显示序号
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: 'single', // 默认单页展示
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number, // 当前题目索引
      default: 0,
    },
    titleNo: {
      type: Number, // 当前题目序号
      default: 0,
    },
    question: {
      type: Object,
      default: () => {},
    },
    answer_json: {
      type: Array,
      default: () => [],
    },
  },
  // subject_title_type: 1 纯文本  2 富文本
  data() {
    return {
      answerList: [],
      qNo: this.titleNo < 9 ? `0${this.titleNo}` : this.titleNo, // 问题序号
    };
  },
  mounted() {
    this.answerList = this.question.option.map((v) => {
      return {
        ...v,
        checked: false,
        details: '',
      };
    });
  },
  methods: {
    hanleSelect(item, idx) {
      for (const item of this.answerList) item.checked = false;
      this.answerList[idx].checked = true;
      this.handleSubmit();
    },
    // 提交答案
    handleSubmit() {
      // 组装提交答案结构
      const answer = this.answerList
        .filter((v) => v.checked)
        .map((item) => {
          return {
            ...item, // 透传所有 option 的值
            option_name: item.option, // 添加名称传过去
            option: item.option_key,
            details: item.details,
            is_empty: item.is_empty,
            is_required: item.is_required ? 1 : 0,
          };
        });
      this.$emit('change', answer, this.index, this.question);
    },
    // 填空输入变化
    handleInputChange(value, idx) {
      this.answerList[idx].details = value;
      this.handleSubmit();
    },
  },
  computed: {
    // 选项引用前题选项的前题
    preQuestion() {
      return this.answer_json[this.question.option_quote_title_num - 1];
    },
    // 标题引用前题选项
    optionsTitle() {
      const preQuestion =
        this.answer_json[this.question.title_quote_title_num - 1];
      if (this.question.title_quote_title_num !== 0 && preQuestion) {
        let optionsNames = '';
        // 判断题 量表题 打分题取同层的 option_name
        if ([3, 4, 5].includes(preQuestion.subject_type)) {
          optionsNames = preQuestion.option;
          if (preQuestion.subject_type === 3) {
            optionsNames = preQuestion.option_name || '';
          }
        } else {
          optionsNames = preQuestion.option
            .map((item) => item.option_name)
            .join(' ');
        }
        return this.question.subject.replace(/【.*?】/, optionsNames);
        // return '【】'
      } else {
        return this.question.subject.replace(/【.*?】/, '');
      }
    },
  },
  watch: {
    preQuestion: {
      deep: true,
      handler: function (val, oldVal) {
        if (this.question.option_quote_title_num !== 0) {
          this.answerList = this.answer_json[
            this.question.option_quote_title_num - 1
          ].option.map((item) => {
            const result = {
              ...item,
              option: item.option_name,
              checked: false,
              details: '',
            };
            delete result.option_name;
            return result;
          });
        }
      },
    },
    answerList: {
      deep: true,
      handler: function () {
        this.handleSubmit();
      },
    },
  },
};
</script>

<style lang="less" scoped>
.sigle-choice {
  display: flex;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }
  .left {
    width: 30px;
    margin-right: 8px;
    text-align: right;
  }
  .right {
    flex: 1;
    .answer-item {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .answer-text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}
</style>
